import {Component, Input, OnInit} from '@angular/core';
import {CrudConfig} from '@ngx-ivengi/crud';
import {DatagridListComponent} from '../datagrid/datagrid-list.component';
import {DatagridBaseComponent} from '../datagrid/datagrid.component';
import {UIRouter} from '@uirouter/angular';
import {Datagrid} from '../datagrid/datagrid.model';
import {Throughput} from '../throughput/throughput.model';
import {ThroughputService} from '../throughput/throughput.service';
import {ChannelService} from './channel.service';

@Component({
  selector: 'app-channel-charge-mgmt',
  templateUrl: '../datagrid/datagrid.component.html'
})
export class ChannelChargeMgmtComponent extends DatagridBaseComponent implements OnInit {

  @Input() public viewMode = false;
  private assignmentFilterId: number = this.crudConfig.getFilterId();

  constructor(
    private crudConfig: CrudConfig,
    private router: UIRouter,
    private channelService: ChannelService,
    private throughputService: ThroughputService
  ) {
    super();
  }

  public ngOnInit() {

    this.requestParams
      .addFilterParam({
        id: this.assignmentFilterId,
        key: 'assignment.id',
        operator: 'eq',
        value: this.router.stateService.params.assignmentId
      });

    this.datagridListComponent.config.blockWrapper = false;
    this.datagridListComponent.config.throughputSubgrid.enabled = true;
    this.datagridListComponent.config.throughputSubgrid.defaultExpanded = true;

    this.datagridListComponent.config.enabledColumns = [
      'building.name',
      'floor.name',
      'assignment.date',
      'channel.throughputCount',
      'channel.dimension',
      'channel.location',
      'channel.finish',
      'channel.remarks',
      'channel.internalRemarks',
      'channel.chargeInclude',
      'channel.chargeUnit',
      'channel.chargeAmount',
      'throughput.chargeInclude',
      'throughput.chargeUnit',
      'throughput.chargeAmount',
      'throughput.status',
    ];

    if(this.router.stateService.current.name.indexOf('assignment.survey') !== -1) {
      this.datagridListComponent.config.enabledColumns.push('channel.recordingFormat');
    } else {
      this.datagridListComponent.config.enabledColumns.push('channel.label');
    }

    this.datagridListComponent.config.inlineEdit = {
      'channel.chargeInclude': {enabled: true, onChange: this.onChange.bind(this)},
      'channel.chargeUnit': {enabled: true, onChange: this.onChange.bind(this)},
      'channel.chargeAmount': {enabled: true, onChange: this.onChange.bind(this)},
      'channel.remarks': {enabled: true, onChange: this.onChange.bind(this)},
      'channel.internalRemarks': {enabled: true, onChange: this.onChange.bind(this)},
      'channel.expander': {enabled: true, onChange: () => {}},
      'throughput.chargeInclude': {enabled: true, onChange: this.onChange.bind(this)},
      'throughput.chargeUnit': {enabled: true, onChange: this.onChange.bind(this)},
      'throughput.chargeAmount': {enabled: true, onChange: this.onChange.bind(this)},
      'throughput.remarks': {enabled: true, onChange: this.onChange.bind(this)},
    };

    this.datagridListComponent.config.onRowChange = this.onRowChange.bind(this);
    this.datagridListComponent.config.rowSelector.onActivate = this.onActivate.bind(this);

    // trigger the super's ngOnInit which finishes configuration of the dataGrid component
    super.ngOnInit();
  }

  public onActivate(event: any) {
    if (event.type === 'click') {
      if( !this.datagridListComponent.config.inlineEdit[event.column.prop]
        || !this.datagridListComponent.config.inlineEdit[event.column.prop].enabled ||
        this.datagridListComponent.config.inlineEdit[event.column.prop].enabled !== true) {
        this.router.stateService.go(`${this.router.stateService.current.name}.channel.edit`, Object.assign(this.router.stateService.params, {channelId: event.row.channel.id}));
      }
    }
  }

  public onChange(datagridRow: Datagrid | Throughput) {
    switch(true) {
      case (datagridRow instanceof Datagrid): {
        this.channelService.patch(datagridRow.channel).subscribe();
      } break;

      case (datagridRow instanceof Throughput): {
        this.throughputService.patch(datagridRow).subscribe();
      } break;
    }
  }

  public onRowChange(rows: Datagrid[], listComponent: DatagridListComponent) {
    listComponent.selected.splice(0, listComponent.selected.length);

    for(const row of rows) {
      if(row.channel.chargeInclude === true) {
        listComponent.selected.push(row);
      }
    }
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/channel/channel-charge-mgmt.component.ts